module.exports = require("@material-ui/core/ExpansionPanelDetails");